import styled from 'styled-components';

const StyledPaymentStatus = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 60px;
  margin: 80px auto;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  text-align: center;
  width: 100%;
  max-width: 500px;
  min-height: calc(60vh - 100px);

  /* Set background for the page */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #f0f4fc;
    z-index: -1;
  }

  .payment-status-img {
    width: 60px;
    margin-bottom: 20px;
    
    &.large {
      width: 200px;
    }
  }

  .payment-status-title {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .payment-status-subtitle {
    font-size: 16px;
    color: #666;
  }

  /* Responsive Styles */
  @media (max-width: 768px) {
    padding: 50px 35px;

    .payment-status-title {
      font-size: 20px;
    }

    .payment-status-subtitle {
      font-size: 14px;
    }
  }

  @media (max-width: 480px) {
    padding: 30px 20px;

    .payment-status-img {
      width: 50px;
    }

    .payment-status-title {
      font-size: 18px;
    }

    .payment-status-subtitle {
      font-size: 13px;
    }
  }
`;

export default StyledPaymentStatus;



// WEBPACK FOOTER //
// client/containers/LyraPaymentStatus/StyledPaymentStatus.js